import React, { useState } from 'react';
import axios from 'axios';

function SettingsPage({ apiUrl, auth }) {
  const [showModal, setShowModal] = useState(false);
  const [password, setPassword] = useState('');
  const [includeProducts, setIncludeProducts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const headers = { Authorization: `Bearer ${auth.token}` };

  const openConfirm = () => {
    setPassword('');
    setMessage(null);
    setShowModal(true);
  };

  const handleReset = async () => {
    if (!password) return;
    setLoading(true);
    setMessage(null);
    try {
      await axios.post(`${apiUrl}/auth/reset`, { password, includeProducts }, { headers });
      setShowModal(false);
      setMessage({ type: 'success', text: 'Données réinitialisées avec succès.' });
    } catch (err) {
      const text = err.response?.data?.error || 'Erreur';
      setMessage({ type: 'error', text });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>⚙️ Paramètres</h1>
      </div>

      {message && (
        <div style={{
          padding: '12px 16px', borderRadius: '10px', marginBottom: '16px', fontWeight: '600',
          background: message.type === 'success' ? '#F0FDF4' : '#FEF2F2',
          color: message.type === 'success' ? '#059669' : '#DC2626',
        }}>
          {message.text}
        </div>
      )}

      <div style={{
        border: '2px solid #FCA5A5', borderRadius: '14px', padding: '24px',
        background: '#FEF2F2', maxWidth: '640px',
      }}>
        <h2 style={{ margin: '0 0 6px', color: '#B91C1C' }}>⚠️ Zone dangereuse</h2>
        <p style={{ color: '#7F1D1D', margin: '0 0 16px', lineHeight: 1.5 }}>
          La réinitialisation supprime <strong>toutes les ventes, dépenses, clients et portefeuilles</strong> et
          remet le compteur de tickets à zéro. Les comptes utilisateurs sont conservés.
          Cette action est <strong>irréversible</strong> — à utiliser uniquement après les tests.
        </p>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', cursor: 'pointer', color: '#7F1D1D' }}>
          <input type="checkbox" checked={includeProducts} onChange={e => setIncludeProducts(e.target.checked)} style={{ width: '18px', height: '18px' }} />
          Supprimer aussi les produits
        </label>
        <div>
          <button
            onClick={openConfirm}
            style={{
              background: '#DC2626', color: 'white', border: 'none', borderRadius: '10px',
              padding: '12px 24px', fontSize: '15px', fontWeight: '700', cursor: 'pointer',
            }}
          >
            Réinitialiser les données
          </button>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2 style={{ color: '#B91C1C' }}>Confirmer la réinitialisation</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
              Entrez votre mot de passe administrateur pour confirmer.
              {includeProducts && ' Les produits seront également supprimés.'}
            </p>
            <div className="form-group">
              <label>Mot de passe administrateur</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Mot de passe"
                autoFocus
                onKeyDown={e => e.key === 'Enter' && handleReset()}
              />
            </div>
            {message && message.type === 'error' && (
              <div style={{ color: '#DC2626', fontWeight: '600', marginBottom: '12px' }}>{message.text}</div>
            )}
            <div className="modal-actions">
              <button className="btn btn-outline" onClick={() => setShowModal(false)}>Annuler</button>
              <button
                onClick={handleReset}
                disabled={loading || !password}
                style={{
                  background: '#DC2626', color: 'white', border: 'none', borderRadius: '8px',
                  padding: '10px 20px', fontWeight: '700', cursor: 'pointer', opacity: (loading || !password) ? 0.6 : 1,
                }}
              >
                {loading ? 'Réinitialisation...' : 'Confirmer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SettingsPage;
